// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./ModalTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal-module__Container__jVp9u {
    display: flex;
    max-height: calc(100% - var(--ds-12x));
    margin: auto;
    /* this is needed because the browser applies modal color to be canvastext */
    color: inherit;
    border-radius: var(--ds-l);
}

.Modal-module__Container__jVp9u::backdrop {
    background: var(--ds-modal-overlay-bg-color);
    backdrop-filter: blur(var(--ds-blur-4));
}
/* Top-anchored variant: pin the top, keep it horizontally centered. */
.Modal-module__ContainerTop__DI8_2 {
    margin-block-start: var(--ds-12x);
}

.Modal-module__FullScreen__ZM30q {
    width: 100%;
    height: 100%;
}

.Modal-module__Modal__DLkQ3 {
    height: auto;
    min-height: 0;
    box-shadow: var(--ds-modal-box-shadow);
    /* stylelint-disable-next-line shorthand-property-no-redundant-values -- DS component  */
    inset-inline: auto auto;
}
/* TODO: fixed heights LUCID-32026 */
.Modal-module__ModalHeightFixed__X1kfh {
    height: var(--ds-vh-80);
    max-height: var(--ds-140x);
}

.Modal-module__ModalWidthLarge__T5dTP {
    width: var(--ds-160x);
}

.Modal-module__ModalWidthMedium__ZLvPK {
    width: var(--ds-140x);
}

.Modal-module__ModalWidthSmall__ffi3_ {
    width: var(--ds-100x);
}

.Modal-module__ModalLabel__aj38k {
    position: absolute;
    top: var(--ds-3x);
    left: var(--ds-3x);
}

.Modal-module__CloseButton__wumNH {
    position: absolute;
    top: var(--ds-2x);
    right: var(--ds-2x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Modal-module__Container__jVp9u`,
	"ContainerTop": `Modal-module__ContainerTop__DI8_2`,
	"FullScreen": `Modal-module__FullScreen__ZM30q`,
	"Modal": `Modal-module__Modal__DLkQ3`,
	"ModalHeightFixed": `Modal-module__ModalHeightFixed__X1kfh`,
	"ModalWidthLarge": `Modal-module__ModalWidthLarge__T5dTP`,
	"ModalWidthMedium": `Modal-module__ModalWidthMedium__ZLvPK`,
	"ModalWidthSmall": `Modal-module__ModalWidthSmall__ffi3_`,
	"ModalLabel": `Modal-module__ModalLabel__aj38k`,
	"CloseButton": `Modal-module__CloseButton__wumNH`
};
export default ___CSS_LOADER_EXPORT___;
